export function notNil<TValue>(value: TValue | null | undefined): value is TValue {
  return value !== null && value !== undefined;
}

export type NonEmptyArray<T> = [T, ...T[]];

export function notEmpty<TValue>(value: TValue[] | NonEmptyArray<TValue>): value is NonEmptyArray<TValue> {
  return value.length > 0;
}
